import React, { Component } from 'react'
import PropTypes from 'prop-types'

import hocConnect from './hocConnect'

export default function (InnerComponent) {
    @hocConnect
    class HocOnChange extends Component {
        static propTypes = {
            ribbonOnChange: PropTypes.func.isRequired,
        }

        onChange = (...params) => {
            const { ribbonOnChange } = this.props

            if (params.length === 3) ribbonOnChange(...params)
            else if (params.length === 2) ribbonOnChange(null, ...params)
            else if (params.length === 1) ribbonOnChange(null, null, ...params)
            else ribbonOnChange(null, null, null)
        }

        render() {
            return <InnerComponent {...this.props} onChange={this.onChange} />
        }
    }

    return HocOnChange
}
